import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import api from "../lib/api";

const KEY = "bogo_modal_date";

export const BogoModal = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [dishes, setDishes] = useState(null);
  const [open, setOpen] = useState(false);

  const eligible = pathname === "/" || pathname.startsWith("/store");

  useEffect(() => {
    if (!eligible || pathname === "/store/jewelry") return;
    const today = new Date().toISOString().slice(0, 10);
    if (localStorage.getItem(KEY) === today) return;
    api.get("/bogo").then(({ data }) => {
      if (!data?.dishes?.length) return;
      setDishes(data.dishes);
      setOpen(true);
      localStorage.setItem(KEY, today);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!open || !dishes) return null;
  const photos = dishes.filter((d) => d.image).slice(0, 4);

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4" data-testid="bogo-modal-overlay"
      style={{ background: "rgba(10,7,2,0.78)", backdropFilter: "blur(4px)" }} onClick={() => setOpen(false)}>
      <div className="relative w-full max-w-lg rounded-3xl p-6 sm:p-8 text-center" data-testid="bogo-modal"
        style={{ background: "linear-gradient(160deg, #171007, #2E2208 55%, #171007)", boxShadow: "0 0 50px rgba(232,179,58,0.35), inset 0 0 60px rgba(232,179,58,0.06)" }}
        onClick={(e) => e.stopPropagation()}>
        <button onClick={() => setOpen(false)} aria-label="Close" data-testid="bogo-modal-close"
          className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center"
          style={{ background: "rgba(243,210,122,0.12)", color: "#F3D27A" }}>
          <X size={18} />
        </button>
        <p className="text-xs font-bold tracking-[0.2em] uppercase" style={{ color: "#C9A95C" }}>Indian Punjabi favorites</p>
        <h2 className="text-2xl sm:text-3xl font-extrabold mt-2" style={{ color: "#F3D27A" }} data-testid="bogo-modal-headline">
          Enjoy BOGO: Buy One, Get One Free
        </h2>
        <p className="text-sm mt-1.5" style={{ color: "#C9A95C" }}>Online pickup and delivery only</p>
        {photos.length > 0 && (
          <div className="flex justify-center gap-3 mt-5 flex-wrap">
            {photos.map((d) => (
              <div key={d.id} className="flex flex-col items-center w-24">
                <img src={d.image} alt={d.name} width="88" height="88" loading="lazy"
                  className="w-[88px] h-[88px] rounded-full object-cover"
                  style={{ boxShadow: "0 0 18px rgba(232,179,58,0.55)", border: "2px solid rgba(232,179,58,0.45)" }} />
                <span className="text-[10px] mt-1.5 leading-tight" style={{ color: "#E8C76E" }}>{d.name}</span>
              </div>
            ))}
          </div>
        )}
        <button data-testid="bogo-modal-order-btn"
          onClick={() => { setOpen(false); navigate("/store/restaurant#bogo"); }}
          className="mt-6 w-full sm:w-auto px-10 py-3.5 rounded-full text-base font-extrabold"
          style={{ background: "linear-gradient(90deg, #E8B33A, #F3D27A)", color: "#171007", boxShadow: "0 0 24px rgba(232,179,58,0.5)" }}>
          Order Now
        </button>
      </div>
    </div>
  );
};

export default BogoModal;
